/** Returns copies of the sections with their navs sorted alphabetically by prettyName. */
export const sortSectionNavs = <T extends { prettyName: string }, S extends { navs: T[] }>(
  sections: S[]
): S[] =>
  sections.map(section => ({
    ...section,
    navs: [...section.navs].sort((a, b) => a.prettyName.localeCompare(b.prettyName))
  }));
